import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import BgImage from "../../assets/images/banner.jpg";
import style from "./ServicesCarousel.module.scss";

const settings = {
  dots: true,
  speed: 500,
  arrows: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};
const ServicesCarausel = () => {
  return (
    <section className={style.chooseVehicle}>
      <img className={style.chooseVehicle__bg} src={BgImage} alt="Bg" />

      <div className={`${style.chooseVehicle__content} container`}>
        <article className={style.chooseVehicle__intro}>
          <h2>Services</h2>
          <p>Style and Comfort from Your Front Door</p>
        </article>

        <div className={style.chooseVehicle__slider}>
          <Slider {...settings}>
            <div>
              <img
                src={"https://d10jr58d84h0rv.cloudfront.net/carousel/1.webp"}
                alt=""
              />
            </div>
            <div>
              <img
                src={"https://d10jr58d84h0rv.cloudfront.net/carousel/2.jpeg"}
                alt=""
              />
            </div>
            <div>
              <img
                src={"https://d10jr58d84h0rv.cloudfront.net/carousel/3.jpeg"}
                alt=""
              />
            </div>
            <div>
              <img
                src={"https://d10jr58d84h0rv.cloudfront.net/carousel/4.jpeg"}
                alt=""
              />
            </div>
            <div>
              <img
                src={"https://d10jr58d84h0rv.cloudfront.net/carousel/5.jpeg"}
                alt=""
              />
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};
export default ServicesCarausel;
